import { render, staticRenderFns } from "./ScrollableWrapper.vue?vue&type=template&id=216f5604"
import script from "./ScrollableWrapper.vue?vue&type=script&lang=js"
export * from "./ScrollableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports